export default __webpack_public_path__ + "static/media/btnhome.4ade15aa.png";